<div fxLayout="column" class="page-container">
  <div fxLayout="column" class="eon-backdrop" fxLayoutAlign="center center">
    <div class="content-container" fxLayoutAlign="center center" fxLayout="column">
      <h1 class="splash-headline" fxLayoutAlign="center center">TCQ Configuration</h1>
      <div class="button-container" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="5px">
        <eon-ui-button text="Question Management" (click)="navigateToQuestionConfig()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>
        <eon-ui-button text="Score Management" (click)="navigateToScoreConfig()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>
        <eon-ui-button text="Misc Settings" (click)="navigateToMiscSettings()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>
        <eon-ui-button text="Reset all Scores" (click)="resetScores()" scheme="white" fullWidth="true" class="primary-button"></eon-ui-button>
      </div>
    </div>
  </div>
</div>
